export const isExperienceEditor = () => {
    const sitecore = window.Sitecore;
    if (sitecore && sitecore.PageModes && sitecore.PageModes.PageEditor) {
        return true;
    }
    else {
        return false;
    }
};
